import { defaultLocale } from './default-locale';

/**
 * @name locales
 * @description Supported locales
 * @type {string[]}
 * @default [defaultLocale]
 */
export const locales: string[] = [
  defaultLocale,
  // Add other locales here as needed
  'de', // German (Swiss German conventions)
  'fr', // French
  'es', // Spanish
  'it', // Italian
];
